/**
 * Unregisters the Angular service worker and clears its caches.
 * Existing clients keep serving a stale app until ngsw is removed once.
 * Leaves firebase-messaging-sw.js alone (push notifications).
 */
export async function unregisterAngularServiceWorker(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  let unregistered = false;

  for (const registration of registrations) {
    const scriptUrl =
      registration.active?.scriptURL ??
      registration.waiting?.scriptURL ??
      registration.installing?.scriptURL ??
      '';
    if (!scriptUrl.includes('ngsw-worker.js')) {
      continue;
    }
    unregistered = (await registration.unregister()) || unregistered;
  }

  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(
      keys
        .filter((key) => key.startsWith('ngsw:') || key.includes('ngsw'))
        .map((key) => caches.delete(key)),
    );
  }

  if (unregistered && !sessionStorage.getItem('muwarid-ngsw-cleared')) {
    sessionStorage.setItem('muwarid-ngsw-cleared', '1');
    location.reload();
  }
}
